module.exports = __webpack_public_path__ + "static/media/img-feature-talent-200.95d6f064.png";